import { useMutation } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  screenshotLink: string;
}

export const useDownloadScreenshot = () => {
  return useMutation({
    mutationFn: async ({ screenshotLink }: HookProps) => {
      const response = await request({
        path: `declarations/getScreenshot?url=${screenshotLink}`,
        method: 'POST',
        authenticate: true,
        fileDownload: true,
      });

      const href = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', 'screenshot.jpeg');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading the screenshot!');
    },
  });
};
